<template>
  <v-form>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-text-field
              v-model="currFilters.name"
              :label="$t('DATA_TABLE.FILTER')"
              clearable
            ></v-text-field>
          </td>
          <td>
            <company-type-filter
              v-model="currFilters.types"
              item-value="id"
              item-text="name"
              :label="$t('DATA_TABLE.FILTER')"
              chips
              multiple
              small-chips
              deletable-chips
            ></company-type-filter>
          </td>
          <td>
            <v-text-field
              v-model="currFilters.street"
              :label="$t('DATA_TABLE.FILTER')"
              clearable
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="currFilters.zip"
              :label="$t('DATA_TABLE.FILTER')"
              clearable
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="currFilters.city"
              :label="$t('DATA_TABLE.FILTER')"
              clearable
            ></v-text-field>
          </td>
          <td>
            <company-status-filter
              v-model="currFilters.status"
              item-value="id"
              item-text="name"
              :label="$t('DATA_TABLE.FILTER')"
              chips
              multiple
              small-chips
              deletable-chips
            ></company-status-filter>
          </td>
          <td colspan="2">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    depressed
                    outlined
                    @click="reset"
                    v-on="on"
                  >
                    <v-icon>mdi-filter-remove</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
              </v-tooltip>
              <v-spacer class="mx-1"></v-spacer>
              <v-btn
                color="primary"
                depressed
                type="submit"
                @click.prevent="setFilters"
              >
                {{ $t('BUTTON.FIND') }}
              </v-btn>
              <v-spacer class="mx-1"></v-spacer>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-form>
</template>

<script>
import CompanyTypeFilter from '@/modules/companies/components/filters/CompanyTypeFilter';
import CompanyStatusFilter from '@/modules/companies/components/filters/CompanyStatusFilter';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listFilters from '@/modules/_global/mixins/list-filters';
import { mapState } from 'vuex';

export default {
  name: 'CompaniesListFilter',

  components: {
    CompanyTypeFilter,
    CompanyStatusFilter
  },

  mixins: [i18nRefreshData, listFilters],

  data() {
    return {};
  },

  computed: {
    ...mapState('company', ['filters']),

    headers() {
      return [
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'types.name'
        },
        {
          text: this.$t('PROFILE.STREET'),
          value: 'street'
        },
        {
          text: this.$t('PROFILE.ZIP'),
          value: 'zip'
        },
        {
          text: this.$t('PROFILE.CITY'),
          value: 'city'
        },
        {
          text: this.$t('PROFILE.STATUS'),
          value: 'status'
        },

        {
          text: '',
          sortable: false
        }
      ];
    }
  },

  methods: {
    reset() {
      this.currFilters = {};
      this.setFilters();
    }
  }
};
</script>
